module.exports = __webpack_public_path__ + "static/innovation_card_img3@2x-2cb547144bdae53f1fdb4297b2ca0e14.jpg";